module.exports = __webpack_public_path__ + "assets/retina_BisectAngleDetailed.49daa2f7617e93aba5a3534c852c04a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_BisectAngleDetailed.png
// module id = 625
// module chunks = 0